// extracted by mini-css-extract-plugin
export default {"mainContainer":"Button_mainContainer__PPUcQ"};